/* eslint-disable react/prop-types */
// CustomUncheckedIcon.js
import React from 'react';
import { Box } from '@mui/material';

const CustomUncheckedIcon = ({ color }) => (
  <Box
    sx={{
      width: 18,
      height: 18,
      border: `1px solid ${color}`,
      borderRadius: '3px',
    }}
  />
);

export default CustomUncheckedIcon;
